<pr-input-abstract
  [isDefault]="isDefault"
  [control]="control"
  [label]="label"
  [derrors]="derrors"
  [class.has-value]="highlightOnValue && hasValue"
  [class.has-focus]="highlightOnFocus && hasFocus"
  (focusin)="hasFocus = true"
  (focusout)="hasFocus = false"
>
  <ngx-intl-tel-input
    #inputTel
    [cssClass]="'custom'"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="true"
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false"
    [selectedCountryISO]="CountryISO.France"
    [maxLength]="15"
    [phoneValidation]="false"
    name="phone"
    [formControl]="control"
    (keyup)="onInputChange($event)"
    (blur)="onBlur(this)"
  ></ngx-intl-tel-input>
</pr-input-abstract>
